import * as React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/src/stylesheets/datepicker.scss";
import "../theme/components/DateInput.scss";

interface IProps {
    label: string;
    name: string;
    value: string;
    required?: boolean;
    className?: string;
    inputClassName?: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

interface ICustomInputProps {
    value?: string;
    onClick?: React.MouseEventHandler<HTMLElement>;
    placeholder?: string;
}

const CustomInput = React.forwardRef<
    HTMLInputElement,
    ICustomInputProps
>(({ value, placeholder, onClick }, ref) => (
    <div className="datepicker-wrapper">
        <input
            ref={ref}
            value={value}
            placeholder={placeholder}
            className="form-control w-100"
            onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
            }}
        />

        <button
            type="button"
            className="calendar-icon-btn"
            onClick={onClick}
            aria-label="Toggle calendar"
        />
    </div>
));

CustomInput.displayName = "CustomInput";

export class DateInput extends React.Component<IProps> {

    public render() {
        const {
            label,
            name,
            required = false,
            className = "mb-3",
            inputClassName = "form-control w-100",
            value
        } = this.props;

        return (
            <div className={className}>
                <label htmlFor={name} className="form-label d-block">{label}</label>

                <DatePicker
                    id={name}
                    selected={this.parseDate(value)}
                    onChange={this.handleDateChange}
                    dateFormat="MM/dd/yyyy"
                    showMonthDropdown={true}
                    showYearDropdown={true}
                    dropdownMode="select"
                    placeholderText="mm/dd/yyyy"
                    wrapperClassName="w-100"
                    className={inputClassName}
                    required={required}
                    customInput={
                        <CustomInput
                            placeholder="mm/dd/yyyy"
                        />
                    }
                />
            </div>
        );
    }

    private parseDate(value: string): Date | null {
        if (!value) {
            return null;
        }

        // for YYYY-MM-DD case
        if (value.includes("-")) {
            const date = new Date(value);

            return isNaN(date.getTime()) ? null : date;
        }

        // for MM/DD/YYYY case
        if (value.includes("/")) {
            const [month, day, year] = value.split("/").map(Number);
            const date = new Date(year, month - 1, day);

            return isNaN(date.getTime()) ? null : date;
        }

        return null;
    }

    private readonly handleDateChange = (date: Date | null): void => {
        const formattedValue = date
            ? date.toISOString().split("T")[0]
            : "";

        const syntheticEvent = {
            target: {
                name: this.props.name,
                value: formattedValue
            }
        } as React.ChangeEvent<HTMLInputElement>;

        this.props.onChange(syntheticEvent);
    };
}
